import React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card, Avatar, CardHeader, CardContent, Box, Grid, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { HealthSystemDomainFarmsResultFarmViewModel } from '../api/HealthSystemApi';

interface FarmCardProps {
  farm: HealthSystemDomainFarmsResultFarmViewModel;
  action: React.ReactElement;
}

const useStyles = makeStyles(() =>
  createStyles({
    headerText: {
      display: 'flex',
      alignItems: 'center'
    },
    cardContent: {
      paddingTop: 0
    }
  })
);

const FarmCard = ({ farm, action }: FarmCardProps) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Box width={1}>
      <Card elevation={1}>
        <CardHeader
          avatar={<Avatar color="primary">{farm.name?.[0]}</Avatar>}
          title={farm.name}
          action={action}
          subheader={farm.number}
        />
        <CardContent className={classes.cardContent}>
          <Grid container>
            {farm.address && (
              <Grid item>
                <Typography variant="subtitle2">{t('f-com-address')}</Typography>
                <Typography variant="body1">{farm.address}</Typography>
              </Grid>
            )}
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default FarmCard;
